var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"m-2"},[_vm._v(" CIERRE COMERCIO ")]),_c('v-card',{staticClass:"pa-5"},[_vm._v(" Contenido de Cierre Comercio ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }